import MixpanelTracker from '../mixpanelTracker';
import Action from '../Model/action';
import {
  ON_EVENT_SOCIAL_MEDIA_CLICK,
  ON_EVENT_SPEAKER_SOCIAL_MEDIA_CLICK,
  ON_EVENT_SPEAKER_CLICK,
  ON_ADD_EVENT_CALENDER_CLICK,
  ON_REMIND_ME_CALENDER_CLICK,
  ON_EVENT_FILTER_CLICK,
  ON_EVENT_DATE_TAB_CLICK,
} from '../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();

export function onClickOfEventSocialMediaLinkTracker(eventData) {
  const properties = {
    Action: Action.CLICK,
    eventData,
  };
  mixpanelTracker.setEventName(ON_EVENT_SOCIAL_MEDIA_CLICK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onClickOfSpeakerSocialMediaLinkTracker(eventData) {
  const properties = {
    Action: Action.CLICK,
    eventData,
  };
  mixpanelTracker.setEventName(ON_EVENT_SPEAKER_SOCIAL_MEDIA_CLICK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onClickOfEventSpeakerTracker(eventData) {
  const properties = {
    Action: Action.CLICK,
    eventData,
  };
  mixpanelTracker.setEventName(ON_EVENT_SPEAKER_CLICK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onClickOfEventCalenderTracker(eventData) {
  const properties = {
    Action: Action.CLICK,
    eventData,
  };
  mixpanelTracker.setEventName(ON_ADD_EVENT_CALENDER_CLICK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onClickOfRemindMeCalenderTracker(eventData) {
  const properties = {
    Action: Action.CLICK,
    eventData,
  };
  mixpanelTracker.setEventName(ON_REMIND_ME_CALENDER_CLICK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onClickOfEventFilterTracker(eventData) {
  const properties = {
    Action: Action.CLICK,
    eventData,
  };
  mixpanelTracker.setEventName(ON_EVENT_FILTER_CLICK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onClickOfEventDateTabTracker(eventData) {
  const properties = {
    Action: Action.CLICK,
    eventData,
  };
  mixpanelTracker.setEventName(ON_EVENT_DATE_TAB_CLICK);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
